<script lang="ts">
  import { onMount } from "svelte";
  import { useStoryblokBridge } from "@storyblok/svelte";
  import StoryblokComponent from "$lib/StoryblokComponent.svelte";
  import { pageTransitionOut, story, textDir } from "$stores";
  import Meta from "$lib/components/Meta.svelte";
  import { getClient } from "$lib/utils/client";
  import CareersItemPage from "$lib/together/landing/CareersItemPage.svelte";
  import { isRtlLanguage } from "$lib/utils/intl";

  export let data;

  getClient();

  $: {
    $story = data;
    $textDir = isRtlLanguage(data.story.lang) ? "rtl" : "ltr";
  }

  onMount(() => {
    useStoryblokBridge(data.story?.id, (newStory) => (data.story = newStory), {
      resolveRelations: [
        "page.page_specific_navigation",
        "postCard.post",
        "newsroomList.latestPostsCategory",
        "post.relatedPosts",
      ],
    });
  });

  const titleSuffix = data.globals.story.content.pageTitleSuffix || "";
</script>

<svelte:head>
  {#if data.story}
    <meta property="og:site_name" content="Zipline" />
    {#if data.story.content.meta?.length}
      <Meta
        blok={data.story.content.meta[0]}
        globals={data.globals.story.content}
      />
    {:else}
      <title>{data.story.name}{titleSuffix}</title>
    {/if}
    {#if data.story.content.hs_content_type}
      {@const contentType = data.story.content.hs_content_type}
      <script data-content-type={contentType}>
        window._hsq = window._hsq || [];
        window._hsq.push([
          "setContentType",
          document.currentScript.dataset.contentType,
        ]);
      </script>
    {/if}
  {/if}
</svelte:head>

<div class:transition-out={$pageTransitionOut} style="z-index: 5">
  {#if data.isCareersSingle}
    <CareersItemPage blok={data.story.content} />
  {:else if data.story}
    <StoryblokComponent blok={data.story.content} />
  {/if}
</div>

<style lang="scss">
  .transition-out {
    position: absolute;
    width: 100%;
    z-index: 6;
  }
</style>
